import styled from '@emotion/styled'
import React, { FC } from 'react'

import { Colors } from 'src/components/theme'

const Container = styled.div`
  position: absolute;
  bottom: 0px;
  margin: 12px;
  padding: 14px;
  background-color: ${Colors.bgWhite};
  border: solid 1px ${Colors.neutral100};
  border-radius: 6px;
`

const Wrapper = styled.div`
  display: flex;
  gap: 12px;
`

const Indicator = styled.div<{ color: string }>`
  width: 20px;
  height: 80px;
  background-image: linear-gradient(${({ color }) => color}, transparent);
`

const LabelsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-weight: 500;
`

type LegendProps = {
  color: string
}

export const Legend: FC<LegendProps> = ({ color }) => {
  return (
    <Container>
      <Wrapper>
        <Indicator color={color} />
        <LabelsContainer>
          <span>High</span>
          <span>Low</span>
        </LabelsContainer>
      </Wrapper>
    </Container>
  )
}
